import React, { KeyboardEvent } from 'react'
import { Segmented } from 'antd'
import { translate } from '../translate'
import styles from './ThreeStateFilter.module.scss'

type Segment = 'all' | 'true' | 'false'

const SEGMENTS: Segment[] = ['all', 'true', 'false']

const ARROW_STEPS: Record<string, number> = {
  ArrowLeft: -1,
  ArrowUp: -1,
  ArrowRight: 1,
  ArrowDown: 1,
}

const toSegment = (value?: boolean | null): Segment =>
  value === true ? 'true' : value === false ? 'false' : 'all'

const fromSegment = (segment: Segment) =>
  segment === 'all' ? undefined : segment === 'true'

export type ThreeStateFilterProps = {
  value?: boolean | null
  onChange?: (value?: boolean) => void
  allTitle?: string
  trueTitle: string
  falseTitle: string
  'aria-labelledby'?: string
}

export const ThreeStateFilter = ({
  value,
  onChange,
  allTitle = translate('all'),
  trueTitle,
  falseTitle,
  'aria-labelledby': ariaLabelledBy,
}: ThreeStateFilterProps) => {
  const titles: Record<Segment, string> = { all: allTitle, true: trueTitle, false: falseTitle }

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    const radios = Array.from(e.currentTarget.querySelectorAll<HTMLInputElement>('input[type=radio]'))
    const from = radios.indexOf(e.target as HTMLInputElement)
    const step = ARROW_STEPS[e.key]

    if (!step || from === -1)
      return

    e.preventDefault()
    const to = (from + step + radios.length) % radios.length
    radios[to].focus()
    onChange?.(fromSegment(SEGMENTS[to]))
  }

  return (
    <Segmented
      role='radiogroup'
      aria-labelledby={ariaLabelledBy}
      className={styles.ThreeStateFilter}
      value={toSegment(value)}
      onChange={segment => onChange?.(fromSegment(segment as Segment))}
      onKeyDown={handleKeyDown}
      options={SEGMENTS.map(segment => ({ value: segment, label: titles[segment] }))}
    />
  )
}
